import { Avatar, Card, Typography, Tabs } from 'antd';
import Meta from 'antd/es/card/Meta';
import React, { useState } from 'react';
import TopSummarySection from '../../TopSummarySection';
import Nudges from '../../Nudges';
import { formatToINR } from '../../../../Utils/utils';
import MutualFundAnalytics from './MutualFundAnalytics';

const { TabPane } = Tabs;

type Props = {
  onBack: () => void;
};

const MutualFunds: React.FC<Props> = ({ onBack }) => {
  const [selectedTab, setSelectedTab] = useState('holdings');

  return (
    <div
      style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
    >
      {/* <div style={{ display: 'flex', width: '100%' }}>
        <LeftOutlined onClick={onBack} />
        <Typography.Title style={{ margin: 0, marginLeft: '25%' }} level={4}>
          Mutual Funds
        </Typography.Title>
      </div> */}

      <TopSummarySection
        isBackButton={true}
        onBack={onBack}
        subTitle={`₹ 3,75,579.33`}
        title='Total Mutual Funds'
        showInvestmentHeader={true}
      />

      {/* <Card
          className='topCard'
          style={{ width: '100%', background: '#0460ff' }}
          actions={[
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                padding: '0px 16px',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <Typography.Text style={{ color: 'white' }}>
                  Invested:
                </Typography.Text>
                <Typography.Text style={{ marginLeft: 10, color: 'white' }}>
                  ₹ 2,49,856.00
                </Typography.Text>
              </div>
            </div>,
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                padding: '0px 16px',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <Typography.Text style={{ fontWeight: 500, color: 'white' }}>
                  P&L
                </Typography.Text>
                <Typography.Text
                  style={{ marginLeft: 10, fontWeight: 600, color: 'white' }}
                >
                  + ₹ 70,473.00{' '}
                  <Typography.Text style={{ color: '#0abb92' }}>
                    (28.21%)
                  </Typography.Text>
                </Typography.Text>
              </div>
            </div>,
          ]}
        >
          <Meta
            className='cardMeta'
            title={<div style={{ color: 'white' }}>₹ 3,20,329.00</div>}
            description={
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  color: 'white',
                }}
              >
                Total Mutual Funds
              </div>
            }
          />
        </Card> */}
      <div style={{ width: '100%', padding: '0 16px', boxSizing: 'border-box' }}>
        <Tabs activeKey={selectedTab} onChange={setSelectedTab} style={{ marginTop: 16 }}>
          <TabPane tab="Holdings" key="holdings">
            <div style={{ paddingTop: 8 }}>
        <Nudges nudgeList={[]} />

        <Card
          style={{ width: '100%', marginTop: 10, marginBottom: 20 }}
          actions={[
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                padding: '0px 16px',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  width: '100%',
                }}
              >
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <Typography.Text style={{ display: 'flex' }}>
                    NAV
                  </Typography.Text>
                  <Typography.Text style={{ display: 'flex', fontWeight: 600 }}>
                    422.67
                  </Typography.Text>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <Typography.Text style={{}}>Total Units</Typography.Text>
                  <Typography.Text style={{ display: 'flex', fontWeight: 600 }}>
                    372.23
                  </Typography.Text>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <Typography.Text style={{}}>Current Value</Typography.Text>
                  <Typography.Text style={{ display: 'flex', fontWeight: 600 }}>
                    {formatToINR(
                      (Math.round(422.67 * 372.23 * 100) / 100).toString()
                    )}
                  </Typography.Text>
                </div>

                {/* <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  width: '38%',
                }}
              >
                <Typography.Text style={{ display: 'flex' }}>
                  Gain/Loss
                </Typography.Text>
                <Typography.Text style={{ display: 'flex', fontWeight: 600 }}>
                  ₹ 31,907{' '}
                  <Typography.Text style={{ color: 'green' }}>
                    (46.67%)
                  </Typography.Text>
                </Typography.Text>
              </div> */}
              </div>
            </div>,
          ]}
        >
          <Meta
            className='mutualFundsName'
            avatar={
              <Avatar
                src={'/images/quant_mf.png'}
                className='imagesMutualFunds'
              />
            }
            title={<div>Quant ELSS Tax Save Fund Direct</div>}
            description={<div>SchemeType : ELSS</div>}
          />
        </Card>

        <Card
          style={{ width: '100%', marginTop: 10 }}
          actions={[
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                padding: '0px 16px',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  width: '100%',
                }}
              >
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <Typography.Text style={{ display: 'flex' }}>
                    NAV
                  </Typography.Text>
                  <Typography.Text style={{ display: 'flex', fontWeight: 600 }}>
                    78.65
                  </Typography.Text>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <Typography.Text style={{}}>Total Units</Typography.Text>
                  <Typography.Text style={{ display: 'flex', fontWeight: 600 }}>
                    1899.31
                  </Typography.Text>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <Typography.Text style={{}}>Current Value</Typography.Text>
                  <Typography.Text style={{ display: 'flex', fontWeight: 600 }}>
                    {formatToINR(
                      (Math.round(1899.31 * 78.65 * 100) / 100).toString()
                    )}
                  </Typography.Text>
                </div>

                {/* <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  width: '38%',
                }}
              >
                <Typography.Text style={{ display: 'flex' }}>
                  Gain/Loss
                </Typography.Text>
                <Typography.Text style={{ display: 'flex', fontWeight: 600 }}>
                  ₹ 31,907{' '}
                  <Typography.Text style={{ color: 'green' }}>
                    (46.67%)
                  </Typography.Text>
                </Typography.Text>
              </div> */}
              </div>
            </div>,
          ]}
        >
          <Meta
            className='mutualFundsName'
            avatar={
              <Avatar
                src={'/images/parag_parikh.jpg'}
                className='imagesMutualFunds'
              />
            }
            title={<div>Parag Parikh Flexi Cap Fund Direct Growth</div>}
            description={<div>SchemeType : Multi Cap Fund</div>}
          />
        </Card>

        <Card
          style={{ width: '100%', marginTop: 20 }}
          actions={[
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                padding: '0px 16px',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  width: '100%',
                }}
              >
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <Typography.Text style={{ display: 'flex' }}>
                    NAV
                  </Typography.Text>
                  <Typography.Text style={{ display: 'flex', fontWeight: 600 }}>
                    271.10
                  </Typography.Text>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <Typography.Text style={{}}>Total Units</Typography.Text>
                  <Typography.Text style={{ display: 'flex', fontWeight: 600 }}>
                    204.79
                  </Typography.Text>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <Typography.Text style={{}}>Current Value</Typography.Text>
                  <Typography.Text style={{ display: 'flex', fontWeight: 600 }}>
                    {formatToINR(
                      (Math.round(271.1 * 204.79 * 100) / 100).toString()
                    )}
                  </Typography.Text>
                </div>

                {/* <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  width: '37%',
                }}
              >
                <Typography.Text style={{ display: 'flex' }}>
                  Gain/Loss
                </Typography.Text>
                <Typography.Text style={{ display: 'flex', fontWeight: 600 }}>
                  ₹ 18,456{' '}
                  <Typography.Text style={{ color: 'green' }}>
                    (19.24%)
                  </Typography.Text>
                </Typography.Text>
              </div> */}
              </div>
            </div>,
          ]}
        >
          <Meta
            className='mutualFundsName'
            avatar={
              <Avatar
                src={'/images/quant_mf.png'}
                className='imagesMutualFunds'
              />
            }
            title={<div>Quant Small Cap Fund Growth Option Direct Plan</div>}
            description={<div>SchemeType : Small Cap Fund</div>}
          />
        </Card>

        <Card
          style={{ width: '100%', marginTop: 10 }}
          actions={[
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                padding: '0px 16px',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  width: '100%',
                }}
              >
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <Typography.Text style={{ display: 'flex' }}>
                    NAV
                  </Typography.Text>
                  <Typography.Text style={{ display: 'flex', fontWeight: 600 }}>
                    39.26
                  </Typography.Text>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <Typography.Text style={{}}>Total Units</Typography.Text>
                  <Typography.Text style={{ display: 'flex', fontWeight: 600 }}>
                    340.03
                  </Typography.Text>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <Typography.Text style={{}}>Current Value</Typography.Text>
                  <Typography.Text style={{ display: 'flex', fontWeight: 600 }}>
                    {formatToINR(
                      (Math.round(340.03 * 39.26 * 100) / 100).toString()
                    )}
                  </Typography.Text>
                </div>

                {/* <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  width: '37%',
                }}
              >
                <Typography.Text style={{ display: 'flex' }}>
                  Gain/Loss
                </Typography.Text>
                <Typography.Text style={{ display: 'flex', fontWeight: 600 }}>
                  ₹ 20,110{' '}
                  <Typography.Text style={{ color: 'green' }}>
                    (23.49%)
                  </Typography.Text>
                </Typography.Text>
              </div> */}
              </div>
            </div>,
          ]}
        >
          <Meta
            className='mutualFundsName'
            avatar={
              <Avatar
                src={'/images/canara_rb.png'}
                className='imagesMutualFunds'
              />
            }
            title={<div>Canara Robeco Small Cap Fund Direct Growth</div>}
            description={<div>SchemeType : Small Cap Fund</div>}
          />
        </Card>

        {/* <Button
        style={{
          fontWeight: 600,
          color: 'white',
          background: '#0460ff',
          width: '100%',
          marginTop: 20,
          height: 40,
        }}
      >
        Invest More
      </Button> */}
            </div>
          </TabPane>
          <TabPane tab="Analytics" key="analytics">
            <MutualFundAnalytics />
          </TabPane>
        </Tabs>
      </div>
    </div>
  );
};

export default MutualFunds;
